module.exports = __webpack_public_path__ + "img/Icon-23.bbcac31c.png";